<template>
  <span class="flex container p4">
    <div>
      <iinput v-if="state.inputs && Object.keys(state.inputs).length > 0" :name="name" v-model="inputs.payload" :value="inputs.payload" />
      <button
        type="button"
        class="fit xs-font p4 indicate"
        @click="testfun(inputs.payload)"
      >
        {{ state.name }}
      </button>
    </div>
    <div
      v-if="outputs && Object.keys(outputs).length > 0 && debug"
      class="v-scroll container success-border p4 m4"
    >
      <b>Return data</b>
      <div>
        <code v-if="typeof outputs == 'string'">{{ outputs }}</code>
        <state v-else tree="tree" :statedata="outputs" />
      </div>
    </div>
  </span>
</template>

<script>
export default {
  computed: {
    state() {
      // First try to find by name in ref.functions, then fallback to direct ID lookup
      if (!this.$store || !this.$store.state || !this.$store.state.app || 
          !this.$store.state.app.advanced || !this.$store.state.app.advanced.functions ||
          !this.$store.state.ref || !this.$store.state.ref.functions) {
        return { name: 'Loading...', inputs: {} };
      }
      const funcId = this.$store.state.ref.functions[this.fun] || this.fun;
      const func = this.$store.state.app.advanced.functions[funcId];
      if (!func) {
        return { name: 'Function not found', inputs: {} };
      }
      return func;
    }
  },
  data() {
    return {
      input: this.value,
      inputs: {
        payload: {},
      },
      outputs: {},
    };
  },
  props: {
    debug: { type: Boolean },
    fun: { type: String },
    name: { type: String },
    size: { type: String },
    value: {
      type: [String, Object, Number, Boolean, Array, Function],
    },
  },
  methods: {
    updatevalue: function (value) {
      this.$set(this, "input", value);
      this.$emit("input", value);
    },
    async testfun(payload) {
      return this.$store
        .dispatch("run", {
          fun: this.fun,
          from: this.name || "function admin",
          payload,
        })
        .then(
          (x) => (this.$set(this, "outputs", x), this.updatevalue(this.outputs))
        );
    },
    initializeInputs() {
      if (this.state && this.state.inputs) {
        Object.keys(this.state.inputs).map((i) =>
          this.$set(this.inputs.payload, i, this.state.inputs[i].static || this.state.inputs[i].type == 'string' ? '' : this.state.inputs[i].type == 'number' ? 1 : this.state.inputs[i].type)
        );
      }
    },
  },
  mounted() {
    console.log({fun: this.fun});
    this.initializeInputs();
  },
  watch: {
    state: {
      handler() {
        if (this.state && this.state.inputs) {
          this.initializeInputs();
        }
      },
      deep: true
    }
  },
};
</script>

<style>
</style>